import BaseAudioMuteButton from "jitsi/base/toolbox/components/BaseAudioMuteButton";
import { IconMicWithBackground } from "jitsi/base/icons/svg";
export class IISightBaseAudioMuteButton extends BaseAudioMuteButton {
    icon = IconMicWithBackground;
}
